import { formatDistanceToNow, parseISO } from "date-fns";
import { Radio } from "lucide-react";

const AEST_FMT = new Intl.DateTimeFormat("en-AU", {
  timeZone: "Australia/Sydney",
  weekday: "short",
  day: "2-digit",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

function formatAEST(iso) {
  try {
    const parts = AEST_FMT.formatToParts(parseISO(iso));
    const get = (t) => parts.find((p) => p.type === t)?.value;
    return `${get("weekday")} ${get("day")} ${get("month")} · ${get("hour")}:${get("minute")}`;
  } catch {
    return "—";
  }
}

export default function StatusBar({ status, isLoading }) {
  if (isLoading || !status) {
    return (
      <div
        data-testid="status-bar"
        className="h-10 rounded-md bg-zinc-900/60 border border-white/10 animate-pulse"
      />
    );
  }

  const lastScan = status.last_scan_at
    ? formatDistanceToNow(parseISO(status.last_scan_at), { addSuffix: true })
    : "never";

  const nextRun = status.next_run_at ? formatAEST(status.next_run_at) : "—";

  return (
    <div
      data-testid="status-bar"
      className="flex flex-wrap items-center gap-x-6 gap-y-2 px-4 py-3 rounded-md bg-[#121214] border border-white/10 font-mono text-xs"
    >
      <span className="flex items-center gap-2 text-zinc-400">
        <Radio
          className={`h-3.5 w-3.5 ${status.is_scanning ? "text-[#FF3B30] animate-pulse" : "text-emerald-400"}`}
        />
        {status.is_scanning ? "SCANNING" : "IDLE"}
      </span>
      <span className="text-zinc-500">
        LAST SCAN:{" "}
        <span data-testid="last-scan-text" className="text-zinc-200">
          {lastScan}
        </span>
      </span>
      <span className="text-zinc-500">
        NEXT RUN:{" "}
        <span data-testid="next-run-text" className="text-zinc-200">
          {nextRun} AEST
        </span>
      </span>
      <span className="text-zinc-500 hidden md:inline">
        SCHEDULER: <span className="text-zinc-200">16:15 AEST daily</span>
      </span>
      <span className="text-zinc-500 hidden sm:inline">
        UNIVERSE:{" "}
        <span className="text-zinc-200">
          {status.last_scan_universe_size ?? "—"}
        </span>
      </span>
    </div>
  );
}
